module.exports = __webpack_public_path__ + "static/img/chanping16.e532ca0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img1/yszq/chanping16.jpg
// module id = padq
// module chunks = 0